<template>
  <component v-bind:is="componentFile"></component>
</template>
<script>
  export default {
    props: {
      componentName: {
        type: String,
        required: true,
        default: 'Default'
      },
      defaultComponentName: {
        type: String,
        required: true,
        default: 'Default'
      }
    },
    computed: {
      componentFile() {
        return this.loadComponent();
      }
    },
    methods: {
      loadComponent() {
        let loadedComponent;
        try {
          require(`./${this.componentName}.vue`);
          loadedComponent = () => import(`./${this.componentName}.vue`);
        } catch (ex) {
          loadedComponent = () => import(`./${this.defaultComponentName}.vue`);
        }
        return loadedComponent;
      }
    }
  }
</script>